import { MParticleShape } from './elog/mparticle_load';

type CommonsWindow = typeof window & {
  mParticle?: Partial<MParticleShape>;
};

export default window as CommonsWindow;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/window_wrapper.ts